"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TITLE = exports.RESET_BUTTON = exports.CELLS = exports.ROWS = exports.THE_BOARD = void 0;
exports.THE_BOARD = document.querySelector('.gameBoard');
exports.ROWS = document.querySelectorAll('.row');
exports.CELLS = document.querySelectorAll('.cell');
exports.RESET_BUTTON = document.querySelector('button');
exports.TITLE = document.querySelector('.title');
